import { useEffect, useRef } from "react";

import { captureWalletEvent, type WalletEventProperties } from "./walletEvents";
import { walletJourney } from "./walletJourney";

export function useWalletHomeAnalytics(properties: WalletEventProperties | null): void {
    const previous = useRef("");
    const key = JSON.stringify(properties);
    useEffect(() => {
        if (!properties || key === previous.current) return;
        previous.current = key;
        captureWalletEvent("wallet:home_viewed", properties, walletJourney.owner());
    }, [key, properties]);
}
